// import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

// interface AdditionalInformationState {
//   sharePercentage: string
//   taxNumber: string
//   taxIssuingCountry: string
//   bankVerificationNumber: string
//   isPEP: string
//   isShareholderCheckboxChecked: boolean
// }

// interface RepresentativeDetailsState {
//   mobileCode: string
//   address: string
//   houseNumber: string
//   firstName: string
//   lastName: string
//   gender: string
//   dateOfBirth: string
//   nationality: string
//   position: string
//   shareholderType: string
//   mobileNumber: string
//   email: string
//   countryOfResidence: string
//   state: string
//   city: string
//   postalCode: string
//   isPEP: string
//   isPartner: string
//   isMember: string
//   isTrustee: string
//   addressNumber: string
//   addressText: string
//   dateOfAppointment: string
//   ssn:any
//   additionalInformation: AdditionalInformationState
// }

// const initialState: RepresentativeDetailsState = {
//   firstName: "",
//   lastName: "",
//   gender: "",
//   dateOfBirth: "",
//   nationality: "",
//   position: "",
//   shareholderType: "",
//   mobileNumber: "",
//   email: "",
//   countryOfResidence: "",
//   state: "",
//   city: "",
//   postalCode: "",
//   isPEP: "",
//   isPartner: "",
//   isMember: "",
//   isTrustee: "",
//   addressNumber: "",
//   addressText: "",
//   dateOfAppointment: "",
//   mobileCode: "",
//   ssn: "",
//   additionalInformation: {
//     sharePercentage: "",
//     taxNumber: "",
//     taxIssuingCountry: "",
//     bankVerificationNumber: "",
//     isPEP: "",
//     isShareholderCheckboxChecked: false,
//   },
//   address: "",
//   houseNumber: ""
// }

// const representativeDetailsSlice = createSlice({
//   name: "representativeDetails",
//   initialState,
//   reducers: {
//     setFirstName: (state, action: PayloadAction<string>) => {
//       state.firstName = action.payload
//     },
//     setLastName: (state, action: PayloadAction<string>) => {
//       state.lastName = action.payload
//     },
//     setGender: (state, action: PayloadAction<string>) => {
//       state.gender = action.payload
//     },
//     setDateOfBirth: (state, action: PayloadAction<string>) => {
//       state.dateOfBirth = action.payload
//     },
//     setNationality: (state, action: PayloadAction<string>) => {
//       state.nationality = action.payload
//     },
//     setPosition: (state, action: PayloadAction<string>) => {
//       state.position = action.payload
//     },
//     setShareholderType: (state, action: PayloadAction<string>) => {
//       state.shareholderType = action.payload
//       if (action.payload === "director" || action.payload === "none") {
//         state.additionalInformation = {
//           sharePercentage: "",
//           taxNumber: "",
//           taxIssuingCountry: "",
//           bankVerificationNumber: "",
//           isPEP: "",
//           isShareholderCheckboxChecked: false,
//         }
//       }
//     },
//     setSharePercentage: (state, action: PayloadAction<string>) => {
//       state.additionalInformation.sharePercentage = action.payload
//     },
//     setTaxNumber: (state, action: PayloadAction<string>) => {
//       state.additionalInformation.taxNumber = action.payload
//     },
//     setTaxIssuingCountry: (state, action: PayloadAction<string>) => {
//       state.additionalInformation.taxIssuingCountry = action.payload
//     },
//     setBankVerificationNumber: (state, action: PayloadAction<string>) => {
//       state.additionalInformation.bankVerificationNumber = action.payload
//     },
//     setIsPEP: (state, action: PayloadAction<string>) => {
//       state.additionalInformation.isPEP = action.payload
//       state.isPEP = action.payload
//     },
//     setIsMember: (state, action: PayloadAction<string>) => {
//       state.isMember = action.payload
//     },
//     setIsPartner: (state, action: PayloadAction<string>) => {
//       state.isPartner = action.payload
//     },
//     setIsTrustee: (state, action: PayloadAction<string>) => {
//       state.isTrustee = action.payload
//     },
//     setAddressNumber: (state, action: PayloadAction<string>) => {
//       state.addressNumber = action.payload
//     },
//     setAddressText: (state, action: PayloadAction<string>) => {
//       state.addressText = action.payload
//     },
//     setDateOfAppointment: (state, action: PayloadAction<string>) => {
//       state.dateOfAppointment = action.payload
//     },
//     setSSN: (state, action: PayloadAction<any>) => {
//       state.ssn = action.payload
//     },
//     setmobileCode: (state, action: PayloadAction<any>) => {
//       state.mobileCode = action.payload
//     },
//     setIsShareholderCheckboxChecked: (state, action: PayloadAction<boolean>) => {
//       state.additionalInformation.isShareholderCheckboxChecked = action.payload
//     },
//     setRepresentativeDetails: (state, action: PayloadAction<Partial<RepresentativeDetailsState>>) => {
//       return { ...state, ...action.payload }
//     },
//     resetRepresentativeDetails: () => initialState,
//   },
// })

// export const {
//   setFirstName,
//   setLastName,
//   setGender,
//   setDateOfBirth,
//   setNationality,
//   setPosition,
//   setShareholderType,
//   setSharePercentage,
//   setTaxNumber,
//   setTaxIssuingCountry,
//   setBankVerificationNumber,
//   setIsPEP,
//   setIsMember,
//   setIsPartner,
//   setIsTrustee,
//   setAddressNumber,
//   setAddressText,
//   setDateOfAppointment,
//   setIsShareholderCheckboxChecked,
//   setRepresentativeDetails,
//   resetRepresentativeDetails,
//   setSSN,
//   setmobileCode
// } = representativeDetailsSlice.actions

// export default representativeDetailsSlice.reducer
import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface AdditionalInformationState {
  sharePercentage: string
  taxNumber: string
  taxIssuingCountry: string
  bankVerificationNumber: string
  isPEP: string
  isShareholderCheckboxChecked: boolean
}

interface RepresentativeDetailsState {
  mobileCode: string
  address: string
  houseNumber: string
  firstName: string
  lastName: string
  gender: string
  dateOfBirth: string
  nationality: string
  position: string
  shareholderType: string
  mobileNumber: string
  email: string
  countryOfResidence: string
  state: string
  city: string
  postalCode: string
  isPEP: string
  isPartner: string
  isMember: string
  isTrustee: string
  addressNumber: string
  addressText: string
  dateOfAppointment: string
  ssn:any
  additionalInformation: AdditionalInformationState
}

const initialState: RepresentativeDetailsState = {
  firstName: "",
  lastName: "",
  gender: "",
  dateOfBirth: "",
  nationality: "",
  position: "",
  shareholderType: "",
  mobileNumber: "",
  email: "",
  countryOfResidence: "",
  state: "",
  city: "",
  postalCode: "",
  isPEP: "",
  isPartner: "",
  isMember: "",
  isTrustee: "",
  addressNumber: "",
  addressText: "",
  dateOfAppointment: "",
  mobileCode: "",
  ssn: "",
  additionalInformation: {
    sharePercentage: "",
    taxNumber: "",
    taxIssuingCountry: "",
    bankVerificationNumber: "",
    isPEP: "",
    isShareholderCheckboxChecked: false,
  },
  address: "",
  houseNumber: ""
}

const representativeDetailsSlice = createSlice({
  name: "representativeDetails",
  initialState,
  reducers: {
    setFirstName: (state, action: PayloadAction<string>) => {
      state.firstName = action.payload
    },
    setLastName: (state, action: PayloadAction<string>) => {
      state.lastName = action.payload
    },
    setGender: (state, action: PayloadAction<string>) => {
      state.gender = action.payload
    },
    setDateOfBirth: (state, action: PayloadAction<string>) => {
      state.dateOfBirth = action.payload
    },
    setNationality: (state, action: PayloadAction<string>) => {
      state.nationality = action.payload
    },
    setPosition: (state, action: PayloadAction<string>) => {
      state.position = action.payload
    },
    setShareholderType: (state, action: PayloadAction<string>) => {
      state.shareholderType = action.payload
      if (action.payload === "director" || action.payload === "none") {
        state.additionalInformation = {
          sharePercentage: "",
          taxNumber: "",
          taxIssuingCountry: "",
          bankVerificationNumber: "",
          isPEP: "",
          isShareholderCheckboxChecked: false,
        }
      }
    },
    setSharePercentage: (state, action: PayloadAction<string>) => {
      state.additionalInformation.sharePercentage = action.payload
    },
    setTaxNumber: (state, action: PayloadAction<string>) => {
      state.additionalInformation.taxNumber = action.payload
    },
    setTaxIssuingCountry: (state, action: PayloadAction<string>) => {
      state.additionalInformation.taxIssuingCountry = action.payload
    },
    setBankVerificationNumber: (state, action: PayloadAction<string>) => {
      state.additionalInformation.bankVerificationNumber = action.payload
    },
    setIsPEP: (state, action: PayloadAction<string>) => {
      state.additionalInformation.isPEP = action.payload
      state.isPEP = action.payload
    },
    setIsMember: (state, action: PayloadAction<string>) => {
      state.isMember = action.payload
    },
    setIsPartner: (state, action: PayloadAction<string>) => {
      state.isPartner = action.payload
    },
    setIsTrustee: (state, action: PayloadAction<string>) => {
      state.isTrustee = action.payload
    },
    setAddressNumber: (state, action: PayloadAction<string>) => {
      state.addressNumber = action.payload
    },
    setAddressText: (state, action: PayloadAction<string>) => {
      state.addressText = action.payload
    },
    setDateOfAppointment: (state, action: PayloadAction<string>) => {
      state.dateOfAppointment = action.payload
    },
    setSSN: (state, action: PayloadAction<any>) => {
      state.ssn = action.payload
    },
    setmobileCode: (state, action: PayloadAction<any>) => {
      state.mobileCode = action.payload
    },
    setIsShareholderCheckboxChecked: (state, action: PayloadAction<boolean>) => {
      state.additionalInformation.isShareholderCheckboxChecked = action.payload
    },
    setRepresentativeDetails: (state, action: PayloadAction<Partial<RepresentativeDetailsState>>) => {
      return { ...state, ...action.payload }
    },
    resetRepresentativeDetails: () => initialState,
  },
})

export const {
  setFirstName,
  setLastName,
  setGender,
  setDateOfBirth,
  setNationality,
  setPosition,
  setShareholderType,
  setSharePercentage,
  setTaxNumber,
  setTaxIssuingCountry,
  setBankVerificationNumber,
  setIsPEP,
  setIsMember,
  setIsPartner,
  setIsTrustee,
  setAddressNumber,
  setAddressText,
  setDateOfAppointment,
  setIsShareholderCheckboxChecked,
  setRepresentativeDetails,
  resetRepresentativeDetails,
  setSSN,
  setmobileCode
} = representativeDetailsSlice.actions

export default representativeDetailsSlice.reducer
